module.exports = __webpack_public_path__ + "static/media/ding.54fef50.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/ding.mp3
// module id = v/iv
// module chunks = 1